


















































































































































































import { Component, Vue } from "vue-property-decorator";
import { authGuard } from "../auth/authGuard";
import { AuthService } from "../services/authService";
import { StudioService } from "../services/roomService";
import StudioManagerEditForm from "@/components/StudioManagerEditForm.vue";
import { StudioState } from "../interfaces/studioState";
import { StudioAttributes } from "../interfaces/studioAttributes";
import BackgroundSettings from "@/interfaces/studioBackground";
import { ReportService } from "@/services/reportService";
import { DateService } from "@/services/dateService";

@Component({
    beforeRouteEnter: authGuard,
    components: { StudioManagerEditForm },
})
export default class StudioManager extends Vue {
    public showDeleteDialog: boolean = false;
    public studioIdToDelete: string = "";
    public editModeCard: string = "";
    public editModeActive: boolean = false;
    public selectedStudio: StudioState | null = null;
    public token: string = "";
    public overallReportGenerating: boolean = false;

    public async mounted() {
        this.token = await this.$auth.getTokenSilently();
    }

    public logo(studio: StudioState) {
        if (studio.backgroundSettings) {
            return `/api/file/by_id/${studio.backgroundSettings.image}`;
        } else return require(`@/assets/logo.svg`);
    }

    public get studios(): { studio: StudioState }[] | [] {
        if (this.$store.state.user) {
            return this.$store.state?.user.own_studios;
        } else return [];
    }
    public joinStudio(studioId: string) {
        this.$router.push({
            name: "Studio",
            params: { studioId: studioId },
        });
    }

    public startEditMode(studio: StudioState) {
        this.selectedStudio = studio;
        this.editModeActive = true;
    }

    public endEditMode() {
        this.editModeActive = false;
        this.selectedStudio = null;
    }

    public async loadUserToStore() {
        // refreshes the studio infos
        if (this.$auth.isAuthenticated) {
            const user = await AuthService.getUser(this.token);
            this.$store.commit("setUser", { user });
        }
    }
    public async addStudio() {
        const resp = await StudioService.addStudio(this.token, {
            participants: "0",
            fullscreenWidgetId: null,
            conferenceActive: false,
            showJoinLeave: false,
        });
        await this.$store.commit("setUser", { user: resp.data });
    }

    public startDeleteStudio(studioId: string) {
        this.studioIdToDelete = studioId;
        this.showDeleteDialog = true;
    }

    public async deleteStudio() {
        const resp = await StudioService.removeStudio(
            this.token,
            this.studioIdToDelete
        );
        this.showDeleteDialog = false;
        this.studioIdToDelete = "";
        if (resp.status == 200) {
            await this.$store.commit("setUser", { user: resp.data });
        } else
            this.$store.commit("showSnackbar", {
                color: "error",
                text: this.$t("studio.deleteError"),
            });
    }
    public async changeStudioAttributes(newAttr: {
        studioId: string;
        attributes: StudioAttributes;
    }) {
        StudioService.updateAttributes(newAttr, this.token);
    }
    public changeBackground(payload: {
        background: BackgroundSettings | null;
        studioId: string;
    }) {
        StudioService.changeBackgroundSettings(
            payload.studioId,
            payload.background,
            this.token
        );
    }

    public hasEvents(studio: StudioState): boolean {
        if (
            studio.events?.some(e => {
                return new Date(e.end_time) > new Date();
            })
        ) {
            return true;
        }
        return false;
    }

    public deletionDisabled(studio: StudioState): boolean {
        // participants
        if (studio.attributes.participants != "0") {
            return true;
        }
        if (this.hasEvents(studio)) {
            return true;
        }
        return false;
    }
    public async generateOverallReport() {
        this.overallReportGenerating = true;
        try {
            await ReportService.createOverallReport(
                `OverallReport_${DateService.formatIsoStringShort(
                    new Date(),
                    this.$i18n.locale
                )}`,
                this.$store.state.user.id,
                this.token
            );
            this.$store.commit("showSnackbar", {
                color: "success",
                text: this.$t("report.saved"),
            });
        } catch (error) {
            this.$store.commit("showSnackbar", {
                color: "error",
                text: error.response.data,
            });
        }
        this.overallReportGenerating = false;
    }
}
